// Action Cable provides the framework to deal with WebSockets in Rails.
// You can generate new channels where WebSocket features live using the `bin/rails generate channel` command.

import { createConsumer } from "@rails/actioncable"

const consumer = createConsumer()

document.addEventListener("turbo:load", () => {
  if (document.querySelector('meta[name="reconnect-cable"]')) {
    consumer.disconnect();
    consumer.connect();
  }
});

export default consumer
